import { render, staticRenderFns } from "./clothOption.vue?vue&type=template&id=1547ce43&scoped=true&"
import script from "./clothOption.vue?vue&type=script&lang=js&"
export * from "./clothOption.vue?vue&type=script&lang=js&"
import style0 from "./clothOption.vue?vue&type=style&index=0&id=1547ce43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547ce43",
  null
  
)

export default component.exports